import axios from '../../../../apis/Api'
import history, { logout } from '../../../../history'
import storage from '../../../../apis/Storage'
import {
  ADD_USER_ROLE_PERMISSIONS,
  DELETE_USER_ROLE_PERMISSIONS,
  GET_USER_ROLE_PERMISSIONS,
} from '../../../../Types'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export const getUserRolePermissions = (id) => async (dispatch) => {
  await axios
    .get(`api/UserRolePagePermission/GetUserRolePagePermissions/${id}`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_USER_ROLE_PERMISSIONS,
        payload: data.response == null ? [] : data.response,
      })
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const addUserRolePermissions = (formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post('api/UserRolePagePermission', formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: ADD_USER_ROLE_PERMISSIONS,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('Permissions assigned successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}

export const deleteUserRolePermissions = (id) => async (dispatch) => {
  const config = {
    headers: { Authorization: `Bearer ${storage.get('_appToken')}` },
  }

  await axios
    .delete(`api/UserRolePermission/${id}`, config)
    .then(() => {
      toast.success('Role deleted successfully')
      dispatch({ type: DELETE_USER_ROLE_PERMISSIONS, payload: id })
    })
    .catch(function (error) {
      dispatch(hideLoading())
      toast.error('Error: ' + error)
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
